import { Button } from "@freightsimple/ui-core/Controls/Button";
import { CustomDocsUpdateDialog } from "@/Shared/CustomDocs/Dialogs/CustomDocsUpdateDialog";
import { DocumentType } from "@freightsimple/generated-dashboard-openapi-client/models/DocumentType";
import type { ReactNode } from "react";
import { useState } from "react";
import type { DocumentsSectionItem } from "@/Shared/Shipment/CustomComponents/ShipmentDocumentsSectionGeneric";
import ShipmentDocumentsSectionGeneric from "@/Shared/Shipment/CustomComponents/ShipmentDocumentsSectionGeneric";

interface DocumentsSectionProps {
  children?: ReactNode | undefined;
  items: Array<DocumentsSectionItem>;
  shipmentId?: string | undefined;
  onReload?: (() => Promise<void>) | undefined;
}

function ShipmentDocumentsSection(props: DocumentsSectionProps) {
  const { items } = props;
  const [updateCustomsDocsOpen, setUpdateCustomsDocsOpen] = useState(false);

  const shouldShowUpdateCustomsButton =
    items.filter((i) => i.documentType === DocumentType.CustomsDocument)
      .length > 0 && props.shipmentId;

  return (
    <>
      {props.shipmentId && (
        <CustomDocsUpdateDialog
          open={updateCustomsDocsOpen}
          onOpenChange={setUpdateCustomsDocsOpen}
          shipmentId={props.shipmentId}
          onDone={() => props.onReload?.()}
        />
      )}
      <ShipmentDocumentsSectionGeneric
        items={items}
        shipmentId={props.shipmentId}
        onReload={props.onReload}
        title={
          <div className="flex w-full flex-row items-end justify-between">
            Documents
            {shouldShowUpdateCustomsButton && (
              <Button onClick={() => setUpdateCustomsDocsOpen(true)}>
                Update Customs Documents
              </Button>
            )}
          </div>
        }
        subtitle="Here are all the documents associated with your shipment."
        sectionId="documents-section"
        thumbnailType="pdf"
      />
    </>
  );
}

export default ShipmentDocumentsSection;
